import { useState } from "react";

const faqs = [
  {
    q: "How do I get an expedited passport in Grand Forks, North Dakota?",
    a: "Grand Forks residents can use Fast Passport Center for 2–9 day expedited processing. Ship documents overnight and we handle agency submission remotely. The nearest regional agency is in Minneapolis at 330+ miles — our service eliminates that trip entirely.",
  },
  {
    q: "Where is the nearest passport agency to Grand Forks, ND?",
    a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 330+ miles from Grand Forks. It requires an appointment and is for genuine life-or-death emergencies only. The Chicago agency is 580+ miles east. Fast Passport Center handles expedited processing without any travel required.",
  },
  {
    q: "How long does passport processing take from Grand Forks?",
    a: "With Fast Passport Center, 2–9 days. Standard post office expedited processing takes 3–5 weeks, and routine processing takes 6–11 weeks. Our courier service is consistently the fastest option for Grand Forks area travelers.",
  },
  {
    q: "Which post offices in Grand Forks accept passport applications?",
    a: "The Grand Forks Main Post Office (2650 S Washington St), Grand Forks Downtown Station (412 DeMers Ave), the Grand Forks County Clerk, and the East Grand Forks Post Office all accept passport applications. We'll tell you exactly which facility to use.",
  },
  {
    q: "Can UND students and faculty use your service?",
    a: "Absolutely. Fast Passport Center regularly assists University of North Dakota students, faculty, and researchers needing passports for study abroad programs, research trips, international conferences, and academic travel. We understand academic timelines and work efficiently.",
  },
  {
    q: "Do I need to travel to Minneapolis for an emergency passport from Grand Forks?",
    a: "Only if you have a documented life-or-death emergency AND travel within 72 hours. For all other urgent situations — including trips within 2–3 weeks — Fast Passport Center provides expedited processing without a 330-mile drive to Minneapolis.",
  },
  {
    q: "How much does expedited passport service cost in Grand Forks?",
    a: "The government fee is $60 for expedited renewal ($130 for new passports) plus a $35 execution fee if submitting in person. Fast Passport Center charges an additional service fee for courier and agent services. Contact us for a complete quote.",
  },
  {
    q: "Can East Grand Forks, MN residents use your service?",
    a: "Yes! Residents of East Grand Forks, Crookston MN, Emerado, Thompson, Larimore, and all surrounding communities are fully covered. The East Grand Forks Post Office (321 Central Ave) is a convenient local acceptance facility for Minnesota side residents.",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Grand Forks Passport Questions Answered
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Everything Grand Forks and surrounding community residents need to know about expedited passport services.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-[#F7F8FA] transition-colors"
              >
                <span className="font-semibold text-[#1A365D] text-sm pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`${openIndex === i ? "ri-subtract-line" : "ri-add-line"} text-[#F6C344] text-lg`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5 text-sm text-gray-500 leading-relaxed border-t border-gray-100 pt-4">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.q,
              acceptedAnswer: { "@type": "Answer", text: faq.a },
            })),
          }),
        }}
      />
    </section>
  );
}